module.exports = __webpack_public_path__ + "img/result1.a95214ac.png";